/*
 * 1-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * CategoryScreen.web.tsx - Shows list of question categories for a given topic
 */

import { TopicCategoryName } from '../../categories';
import './CategoryScreen.web.css';
import { RootStackProps } from '../../navigation/types';

const CategoryScreen = ({ route, navigation }: RootStackProps<'Category'>) => {
  const {name, categories} = route.params;

  return (
    <div id="category_wrapper">

      <div id="category_header">
        <div className="category_logo">
          <img
            className="category_logo_image"
            src={require('../../assets/images/TinySmile_72dpi.png')}
          />
        </div>

        <div className="category_brand">
          <img
            className="category_brand_image"
            src={require('../../assets/images/logo-wrm-home.svg')}
          />
        </div>
      </div>

      <div id="category_content">

        {categories.map((category, index) => {
          return (
            <div className="category_ButtonView" key={index}>
              <button
                onClick={() => name === TopicCategoryName.SUBITISING ?
                  navigation.navigate('Subitising', category) :
                  navigation.navigate('Questions', category)
                }
                className="category_page_button"
                onMouseEnter={() => {
                  const imageContainer = document.getElementById(`buttonImageContainer${category.name}`);
                  const textContainer = document.getElementById(`buttonTextContainer${category.name}`);
                  imageContainer?.classList.add('blue_border');
                  textContainer?.classList.add('blue_border');
                  textContainer?.classList.add('wider_letters');
                }}
                onMouseLeave={() => {
                  const imageContainer = document.getElementById(`buttonImageContainer${category.name}`);
                  const textContainer = document.getElementById(`buttonTextContainer${category.name}`);
                  imageContainer?.classList.remove('blue_border');
                  textContainer?.classList.remove('blue_border');
                  textContainer?.classList.remove('wider_letters');
                }}
              >

                <div
                  className="category_page_button_image_container"
                  style={{ backgroundColor: category.color }}
                  id={`buttonImageContainer${category.name}`}
                >
                  <p className="category_page_button_image_text">{index + 1}</p>
                </div>

                <div
                  className="category_page_button_text_container"
                  style={{ backgroundColor: '#b9dde2' }}
                  id={`buttonTextContainer${category.name}`}
                >

                  <p className="category_button_text">
                    {' '}
                    {category.name}
                    {' '}
                  </p>
                </div>

              </button>
            </div>
          );
        })}

      </div>

    </div>
  );
};

export default CategoryScreen;
